import { getFunctions, httpsCallable } from 'firebase/functions';
import { app } from '../firebase';

export const createLivePaymentIntent = async ({ trackId, licenseType = 'standard' }) => {
    const functions = getFunctions(app);
    const createPaymentIntent = httpsCallable(functions, 'createPaymentIntent');
    const result = await createPaymentIntent({ trackId, licenseType });
    return result.data;
};

export const createConnectOnboardingLink = async () => {
    const functions = getFunctions(app);
    const createOnboardingLink = httpsCallable(functions, 'createConnectOnboardingLink');
    const result = await createOnboardingLink();
    return result.data;
};

export const refreshConnectAccountStatus = async () => {
    const functions = getFunctions(app);
    const refreshStatus = httpsCallable(functions, 'refreshConnectAccountStatus');
    const result = await refreshStatus();
    return result.data;
};

export const requestWithdrawal = async ({ amount }) => {
    const functions = getFunctions(app);
    const requestWithdrawalCallable = httpsCallable(functions, 'requestWithdrawal');
    const result = await requestWithdrawalCallable({ amount });
    return result.data;
};

export const listWithdrawalRequests = async ({ status = 'pending', limit = 25 } = {}) => {
    const functions = getFunctions(app);
    const listWithdrawalRequestsCallable = httpsCallable(functions, 'listWithdrawalRequests');
    const result = await listWithdrawalRequestsCallable({ status, limit });
    return result.data;
};

export const markWithdrawalPaid = async ({ withdrawalId, note = '' }) => {
    const functions = getFunctions(app);
    const markWithdrawalPaidCallable = httpsCallable(functions, 'markWithdrawalPaid');
    const result = await markWithdrawalPaidCallable({ withdrawalId, note });
    return result.data;
};
